export default {
  placeholder: 'Select unit system',
};
